import { render, staticRenderFns } from "./ClinicalEventList.vue?vue&type=template&id=83cc5396&scoped=true&"
import script from "./ClinicalEventList.vue?vue&type=script&lang=js&"
export * from "./ClinicalEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cc5396",
  null
  
)

export default component.exports